import OrderSummaryTile from "./OrderSummaryTile";
import OrderSummaryTileViews from "./OrderSummaryTileViews";

export { OrderSummaryTileViews };
export default OrderSummaryTile;
